import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, loginResponse, logoutUserSuccess } from "./actions";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postLogin } from "../../../helpers/backend_helper";
import { postSocialLogin } from "../../../helpers/fakebackend_helper";
import { isLoading } from "../../actions";

const fireBaseBackend = getFirebaseBackend();

export function* loginUser({ payload: { user } }) {
  try {
    console.log("🔵 [Saga] Login request:", user);

    yield put(isLoading(true));

    const response = yield call(postLogin, {
      email: user.email,
      password: user.password,
      role: user.role,
      otp: user.otp,
    });

    console.log("✅ [Saga] API Response:", response);

    // Check if this is a successful login with token
    if (response.status === 200 && response.accessToken) {
      console.log("✅ [Saga] Login successful with token");
      localStorage.setItem("accessToken", response.accessToken);
      localStorage.setItem("authUser", JSON.stringify(response.jwtInformation));
      localStorage.setItem("role", response.jwtInformation.role);
      yield put(loginSuccess(response));
    }
    // Check if OTP is required
    else if (response.requiresOtp || (response.status === 200 && !response.accessToken)) {
      console.log("📧 [Saga] OTP required");
      yield put(loginResponse(response));
    }
    // Check if multiple roles are available
    else if (response.status === 300 && response.roles) {
      console.log("👥 [Saga] Multiple roles found");
      yield put(loginResponse(response));
    }
    // Other responses
    else {
      console.log("ℹ️ [Saga] Other response:", response);
      yield put(loginResponse(response));
    }

  } catch (error) {
    console.error("❌ [Saga] Login error:", error);

    const errorMessage = error?.response?.data?.message || error?.message || "Login failed";
    const errorData = error?.response?.data;

    // Check if error response contains role selection info
    if (errorData?.status === 300 && errorData?.roles) {
      console.log("👥 [Saga] Multiple roles in error response");
      yield put(loginResponse(errorData));
    } else {
      yield put(apiError(errorMessage));
    }
  } finally {
    yield put(isLoading(false));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("accessToken");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;